import React, { useState } from 'react';
import store from '@carvana/purchase-store';
import Checkbox from '@carvana/forms/Checkbox';
import { CarvanaButton } from '@carvana/purchase-styles';
import * as sc from './document-questionnaire.styles';
import * as documentWizardStyles from '../../document-wizard-modal.styles';

const DocumentQuestionnaire = props => {
  const { wizardConfig, verifiedDocument, document } = props;

  const [checkboxes, setCheckboxes] = useState([false]);
  const [enableButton, setEnableButton] = useState(false);

  const setAnswers = index => {
    checkboxes[index] = !checkboxes[index];
    setCheckboxes(checkboxes);
    setEnableButton(checkboxes.every(x => x === true));
  };

  return (
    <sc.Wrapper>
      <documentWizardStyles.FormHeading>
        {wizardConfig.verifyHeading}
      </documentWizardStyles.FormHeading>
      <documentWizardStyles.WizardText>
        Check box to continue
      </documentWizardStyles.WizardText>

      <sc.CheckboxContainer>
        <Checkbox
          id="checkBox1"
          label={<sc.RadioLabel>All 4 corners are visible</sc.RadioLabel>}
          value={checkboxes[0]}
          onChange={() => setAnswers(0)}
        />
      </sc.CheckboxContainer>

      <sc.ButtonContainer>
        <CarvanaButton disabled={!enableButton} onClick={() => store.dispatch(verifiedDocument(document))}>
          LOOKS GOOD
        </CarvanaButton>
      </sc.ButtonContainer>
    </sc.Wrapper>
  );
};

export default DocumentQuestionnaire;
